// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"fullscreen-2"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M5.88389 5.88387L9 8.99999M9 5H5V9M5.88386 18.1161L8.99998 15M5 15L5 19H9M18.1161 5.88387L15 8.99999M15 5H19V9M18.1161 18.1161L15 15M19 15V19H15","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-fullscreen-2')
export default class Fullscreen2Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'fullscreen-2',
    }
  }
}
